import './lang/i18n';
import 'babel-polyfill';
import React, { Suspense } from 'react';
import 'ag-grid-enterprise';
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { LicenseManager as ChartLicenseManager } from "ag-charts-enterprise";
import configureStore from './store/configureStore';
import configureStoreProduction from './store/configureStoreProduction';
import ReactDOM from "react-dom/client";
import RoutesComponent from './routes';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/css/bootstrap-theme.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min';
import '../node_modules/jquery/dist/jquery.min';
import './static/multiselect'
import './styles/sass/site.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './static/multiselect';

// AG Grid
ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-073584}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TechPOS_International_Corp}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Techpos}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Techpos}_need_to_be_licensed___{Techpos}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{13_December_2025}____[v3]_[0102]_MTc2NTU4NDAwMDAwMA==050c1b5e8f71bd7a621b3b444da8da98");
// AG Chart
ChartLicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-073584}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TechPOS_International_Corp}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Techpos}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Techpos}_need_to_be_licensed___{Techpos}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{13_December_2025}____[v3]_[0102]_MTc2NTU4NDAwMDAwMA==050c1b5e8f71bd7a621b3b444da8da98")

const store =
    // process.env.NODE_ENV === 'development' ?
    configureStore()
// : configureStoreProduction();
const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <Suspense fallback={<div>Loading…</div>}>
    <RoutesComponent store={store} />
  </Suspense>
);